import { render, staticRenderFns } from "./briefing.vue?vue&type=template&id=50a069ac&scoped=true&"
import script from "./briefing.js?vue&type=script&lang=js&"
export * from "./briefing.js?vue&type=script&lang=js&"
import style0 from "./briefing.vue?vue&type=style&index=0&id=50a069ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a069ac",
  null
  
)

export default component.exports